export default __webpack_public_path__ + "static/O0194-2d62d029a95fd223af3c8435b4e94894.png";